import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Page } from '../../shared/models/page';
import { Customer, CustomerPayload, CustomerStatementRow } from '../models/customer.model';
import { PagePayload } from '../../shared/models/common.model';
import { handleHttpParams } from '../../shared/utils/common';
import { SupplierStatementResponse } from '../../suppliers/models/supplier.model';

@Injectable({
    providedIn: 'root',
})
export class CustomerService {
    tableName: string = 'customers';
    constructor(protected readonly http: HttpClient) {}

    getCustomers(payload: PagePayload): Observable<Page<Customer>> {
        const httpParams = handleHttpParams(payload);
        return this.http.get<Page<Customer>>(this.tableName, {
            params: httpParams,
        });
    }

    getCustomerById(id: number): Observable<Customer> {
        return this.http.get(`${this.tableName}/${id}`);
    }

    addCustomer(payload: CustomerPayload): Observable<Customer> {
        return this.http.post(this.tableName, payload);
    }

    deleteCustomer(id: number): Observable<Customer> {
        return this.http.delete(`${this.tableName}/${id}`);
    }

    updateCustomer(id: number, updateCustomerPayload: CustomerPayload): Observable<Customer> {
        return this.http.put(`${this.tableName}/${id}`, updateCustomerPayload);
    }

    getCustomerStatementPage(
        id: number,
        start: Date,
        end: Date,
        limit?: number,
        offset?: number,
    ): Observable<Page<CustomerStatementRow>> {
        const timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let params = new HttpParams()
            .append('start', start.toISOString())
            .append('end', end.toISOString())
            .append('timezone', timezone);
        if (limit) {
            params = params.append('limit', limit);
        }
        if (offset) {
            params = params.append('offset', offset);
        }
        return this.http.get<SupplierStatementResponse>(`customers/${id}/statement`, { params });
    }
}
